<template>
  <div class="coupon-item-ctn">
    <div class="coupon-item">
      <div class="ui-nowrap coupon-name">{{ name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: String
  }
}
</script>
<style lang="scss" scoped>
.coupon-item-ctn {
  display: flex;
  align-items: center;
  padding-top: 0.015rem;
  // height: .3rem;
  // background-color: beige;
}
.coupon-item {
  display: inline-block;
  position: relative;
  // top: 0.015rem;
  height: 0.3rem;
  overflow: hidden;
  &::before,
  &::after {
    position: absolute;
    left: -0.05rem;
    top: 50%;
    content: '';
    width: 0.1rem;
    height: 0.1rem;
    border: 0.5px solid #ff5900;
    border-radius: 50%;

    margin-top: -0.06rem;
    background: #fff;
  }
  .coupon-name {
    height: 0.28rem;
    font-size: 0.2rem;
    color: #ff5900;
    padding: 0 0.1rem;
    border: 0.5px solid #ff5900;
    border-radius: 0.05rem;
    max-width: 4.8rem;
    line-height: 1;
    padding-top: 0.045rem;
  }

  &::after {
    left: unset;
    right: -0.05rem;
  }
}
</style>
